export { default } from './ExtraInformation';
